module.exports = __webpack_public_path__ + "media/images/feature-6-25049331.png";